<mat-tab-group mat-stretch-tabs mat-align-tabs="center">

  <mat-tab i18n-label="@@distributorPlans" label="Distributor Plans">
    <div class="pricing-container">
      <div i18n="@@weHavePlanForEveryone" class="mat-headline-4 text-center mb-34">We have a plan for everyone!</div>
      <div class="cards-container">

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@lite" class="mat-headline-4 mb-24 d-inline-flex">Lite</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-65">
              <div i18n="@@freeOfChanrge" class="d-inline mat-heading">€ FOC</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-caption mb-24">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 450</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@register" data-testid="openSignup_button" (click)="openSignup('distributor', 'lite', 0, 420, 0)" mat-raised-button color="primary" class="w-100">Register</button>
          </mat-card-actions>
        </mat-card>

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@bronze" class="mat-headline-4 mb-24">Bronze</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€4,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">5 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 400</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@subscribe" data-testid="openSignup_button" (click)="openSignup('distributor', 'bronze', 5, 400, 4950)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          </mat-card-actions>
        </mat-card>

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@silver" class="mat-headline-4 mb-24">Silver</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€ 6,700</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">10 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 375</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@subscribe" data-testid="openSignup_button" (click)="openSignup('distributor', 'silver', 10, 375, 6700)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          </mat-card-actions>
        </mat-card>

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@gold" class="mat-headline-4 mb-24">Gold</div>
            <div class="star-box mb-24">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-24">
              <div class="d-inline mat-heading">€9,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-24">20 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 350</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@subscribe" data-testid="openSignup_button" (click)="openSignup('distributor', 'gold', 20, 350, 9950)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          </mat-card-actions>
        </mat-card>
      </div>

      <div i18n="@@joinFreeTrialMessage" class="mat-headline-5 text-center mb-16">Join us to have 3 months free trial*, and enjoy your trial access**.</div>
      <button i18n="@@signUp" data-testid="openSignup_button" (click)="openSignup('distributor', 'free', 0, 420, 0)" mat-raised-button color="accent" class="signup-button mb-16">Sign up</button>
      <div i18n="@@afterTrialMessage" class="mat-caption text-center mb-16 size-12">*After trial ends, your account will automatically change to lite version.</div>
      <div i18n="@@noAdditionalMobileSubscriptions" class="mat-caption text-center mb-16 size-12">**You will not be able to buy (additional) mobile subscription</div>

      <mat-card class="info-box">
        <mat-card-content>
          <div class="w-50 m-16 mb-30">
            <mat-icon color="primary" aria-label="Register your own products" i18n-aria-label="@@registerOwnProductsIcon">fiber_manual_record</mat-icon>
            <div i18n="@@registerOwnProducts" class="d-inline mat-caption info-text">Register your own products.</div>
          </div>
          <div class="w-50 m-16 mb-30">
            <mat-icon color="primary" aria-label="Mobile app preview" i18n-aria-label="@@mobileAppPreviewIcon">fiber_manual_record</mat-icon>
            <div i18n="@@mobileAppViewMessage" class="d-inline mat-caption info-text">Mobile application preview using web-application credentials.</div>
          </div>
          <div class="w-50 m-16">
            <mat-icon color="primary" aria-label="Add manufacturer products" i18n-aria-label="@@addManufacturerProductsIcon">fiber_manual_record</mat-icon>
            <div i18n="@@addManufacturerProducts" class="d-inline mat-caption info-text">Add manufacturer registered products.</div>
          </div>
          <div class="w-50 m-16">
            <mat-icon color="primary" aria-label="Add manufacturer info" i18n-aria-label="@@addManufacturerInfoIcon">fiber_manual_record</mat-icon>
            <div i18n="@@addManufacturerInfo" class="d-inline mat-caption info-text">Add on to manufacturer registered information.</div>
          </div>
        </mat-card-content>
      </mat-card>

      <div i18n="@@liteVersionDescription" class="mat-caption text-center mb-16 size-12">Our lite version allows you to receive and share manufacturer provided information only.</div>
      <div i18n="@@afterTrialPeriodDescription" class="mat-caption text-center mb-16 size-12">After the trial period you will not lose your information but they will not be accessible or shared using the lite version.</div>
      <div class="mat-caption mb-0">
        <span i18n="@@largerPlansMessage">Interested in one of our larger platinum, diamond or emerald packages? please </span>
        <a i18n="@@conatctUs" routerLink="/contact-us">contact us!</a>
      </div>
    </div>
  </mat-tab>

  <mat-tab i18n-label="@@manufacturerPlans" label="Manufacturer Plans">
    <div class="pricing-container">
      <div i18n="@@weHavePlanForEveryone" class="mat-headline-4 text-center mb-34">We have a plan for everyone!</div>
      <div class="cards-container">

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@bronze" class="mat-headline-4 mb-30">Bronze</div>
            <div class="star-box mb-30">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-30">
              <div class="d-inline mat-heading">€4,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-30">5 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
              <span class="subscription-color"> € 400</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@subscribe" data-testid="openSignup_button" (click)="openSignup('manufacturer', 'bronze', 5, 400, 4950)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          </mat-card-actions>
        </mat-card>

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@silver" class="mat-headline-4 mb-30">Silver</div>
            <div class="star-box mb-30">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-30">
              <div class="d-inline mat-heading">€ 6,700</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-30">10 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just </span>
              <span class="subscription-color"> € 375</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@subscribe" data-testid="openSignup_button" (click)="openSignup('manufacturer', 'silver', 10, 375, 6700)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          </mat-card-actions>
        </mat-card>

        <mat-card>
          <mat-card-content class="box-padding">
            <div i18n="@@gold" class="mat-headline-4 mb-30">Gold</div>
            <div class="star-box mb-30">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate.svg" alt="Star" i18n-alt="@@starRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
              <img src="../../../assets/images/star-rate-gray.svg" alt="Empty star" i18n-alt="@@emptyStarRating">
            </div>
            <div class="mb-30">
              <div class="d-inline mat-heading">€9,950</div>
              <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
            </div>
            <div class="mat-heading subscription-color mb-30">20 <span i18n="@@subscribtions">Subscriptions</span></div>
            <div class="mat-caption">
              <span i18n="@@getExtraSubscription">Get 1 extra subscription for just </span>
              <span class="subscription-color"> € 350</span>
            </div>
          </mat-card-content>
          <mat-card-actions class="button-margin">
            <button i18n="@@subscribe" data-testid="openSignup_button" (click)="openSignup('manufacturer', 'gold', 20, 350, 9950)" mat-raised-button color="primary" class="w-100">Subscribe</button>
          </mat-card-actions>
        </mat-card>
            </div>
            <div i18n="@@joinFreeTrialMessage" class="mat-headline-5 text-center mb-16">Join us to have 3 months free trial*, and enjoy your unlimited access**.</div>
            <button i18n="@@signUp" data-testid="openSignup_button" (click)="openSignup('manufacturer', 'free', 0, 400, 0)" mat-raised-button color="accent" class="signup-button mb-16">Sign up</button>
            <div i18n="@@purchaseAnyPlanMessage" class="mat-caption text-center mb-16 size-12">After or during your trial you will have the ability to purchase any of the above plans. Your account will be automatically put on inactive after the trial period. If you like to delete your account please contact us.</div>
            <mat-card class="info-box">
                <mat-card-content>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="Register products and all applicable information" i18n-aria-label="@@registerProductsIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@registerProducts" class="d-inline mat-caption info-text ">Register products and all applicable information.</div>
                    </div>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="Manage approvals" i18n-aria-label="@@manageApprovalsIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@manageApprovals" class="d-inline mat-caption info-text ">Manage approvals.</div>
                    </div>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="Events calendar" i18n-aria-label="@@eventsCalendarIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@eventsCalendar" class="d-inline mat-caption info-text ">Events calendar.</div>
                    </div>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="View statistics" i18n-aria-label="@@viewStatisticsIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@viewStatistics" class="d-inline mat-caption info-text ">View statistics.</div>
                    </div>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="Upload and manage regulatory documents" i18n-aria-label="@@uploadDocumentsIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@uploadDocuments" class="d-inline mat-caption info-text ">Upload and manage regulatory documents.</div>
                    </div>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="Mobile application preview using web-application credentials" i18n-aria-label="@@mobileAppViewIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@mobileAppViewMessage" class="d-inline mat-caption info-text ">Mobile application preview using web-application credentials.</div>
                    </div>
                    <div class="w-50 m-16">
                        <mat-icon color="primary" aria-label="Approve sharing of registered product information with distributors" i18n-aria-label="@@approveSharingIcon">fiber_manual_record</mat-icon>
                        <div i18n="@@ApproveSharingProductInfo" class="d-inline mat-caption info-text ">Approve sharing of registered product information with distributors.</div>
                    </div>
                </mat-card-content>
            </mat-card>
             <div class="mat-caption mb-0"><span i18n="@@largerPlansMessage">Interested in one of our larger platinum, diamond or emerald packages? please </span>
                <a i18n="@@conatctUs" routerLink="/contact-us">contact us!</a>
        </div>
    </div>
  </mat-tab>
</mat-tab-group>
